import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pharmacy = _resolveComponent("Pharmacy")!
  const _component_PatientDME = _resolveComponent("PatientDME")!
  const _component_PatientSupply = _resolveComponent("PatientSupply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pharmacy),
    _createVNode(_component_PatientDME, {
      dmes: _ctx.patientDetails.dmEs,
      "onUpdate:dmes": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.dmEs) = $event)),
      "order-id": _ctx.patientDetails.associatedTaskId,
      "patient-status": _ctx.patientDetails.status,
      "is-referral": _ctx.patientDetails.isReferral,
      "provider-id": _ctx.patientDetails.providerId,
      "patient-vendors": _ctx.patientDetails.dmeVendors,
      "onUpdate:patient-vendors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientDetails.dmeVendors) = $event))
    }, null, 8 /* PROPS */, ["dmes", "order-id", "patient-status", "is-referral", "provider-id", "patient-vendors"]),
    _createVNode(_component_PatientSupply, {
      supplies: _ctx.patientDetails.supplies,
      "onUpdate:supplies": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patientDetails.supplies) = $event)),
      "order-id": _ctx.patientDetails.associatedTaskId,
      "patient-status": _ctx.patientDetails.status,
      "is-referral": _ctx.patientDetails.isReferral,
      "provider-id": _ctx.patientDetails.providerId
    }, null, 8 /* PROPS */, ["supplies", "order-id", "patient-status", "is-referral", "provider-id"])
  ], 64 /* STABLE_FRAGMENT */))
}